export default __webpack_public_path__ + "static/media/warning--skewed-t-roads-right--g1.48a80ba7.png";